import { createApolloClient } from '@polf/shared/apollo'
import { possibleTypesData } from '@polf/shared/codegen'

import { getActivePlayerKey } from './auth-state'

/**
 * Single Apollo client — the player app is player-scoped end-to-end. Public
 * spectator (polf-event-key) lives in `packages/projector`.
 *
 * possibleTypes: generated by @graphql-codegen/fragment-matcher (see
 * packages/shared/graphql-codegen.yml). Without it, InMemoryCache silently
 * strips fields selected via `... on X` because it can't discriminate
 * the variant at read time. Regenerated alongside types on every `yarn
 * codegen` so it stays in sync with the schema.
 */
const { possibleTypes } = possibleTypesData

export const apolloPlayer = createApolloClient({
  authMode: 'player',
  uri: '/graphql',
  getNanoIdKey: getActivePlayerKey,
  possibleTypes,
  // Fairways are not cellular paradises: bound every request so a save hung on
  // flaky signal rejects (and the score buttons re-enable) instead of freezing
  // the grid on a spinner that never resolves.
  operationTimeoutMs: 12_000,
})
